(function ErezReportFutureAirDepositsForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'ReportFutureAirDeposits',
	};

	$(document).ready(function documentReady() {
		Adzuki.Form.registerForm(form);
	});

	form.load = function load()
	{
		Adzuki.Typeahead(
			'#reportfutureairdeposits-search_term',
			'/Clients/search',
			function select(item) {
				$("#reportfutureairdeposits-client_id").val(item.id);
			}
		);
	};

}(jQuery, window.Adzuki || {}));
